/**
 * Benutzerliste zum Freischalten einer Funktion (#1245, Word-Plugin) — wie bei
 * der KI-Freischaltung auf #1336: Suche über Name und E-Mail, Haken je Person.
 */

interface ISearchableUser {
  idUser: number;
  FirstName?: string | null;
  LastName?: string | null;
  Email?: string | null;
}

/** Haken setzen oder entfernen. Er hängt an der id, nicht an der sichtbaren Liste. */
export const toggleUserId = (selected: number[], idUser: number): number[] =>
  selected.includes(idUser)
    ? selected.filter(entry => entry !== idUser)
    : [...selected, idUser];

/** Die Suche blendet Zeilen aus, hebt aber keine Freischaltung auf. */
export const filterUsersBySearch = <T extends ISearchableUser>(
  users: T[],
  search: string
): T[] => {
  const term = search.trim().toLocaleLowerCase();

  if (term === '') {
    return users;
  }

  return users.filter(user =>
    `${user.LastName ?? ''} ${user.FirstName ?? ''} ${user.Email ?? ''}`
      .toLocaleLowerCase()
      .includes(term)
  );
};
